import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Menu from './Menu';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/menus/main.scss';

const propTypes = {
    topItems: AppPropTypes.menuItems,
    bottomItems: AppPropTypes.menuItems,
    color: PropTypes.string,
    theme: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    topItems: [],
    bottomItems: [],
    color: null,
    theme: null,
    className: null,
};

const MainMenu = ({ topItems, bottomItems, color, theme, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <Menu className={styles.top} color={color} theme={theme} items={topItems} />
        <Menu className={styles.bottom} color={color} theme={theme} items={bottomItems} hasReturn />
    </div>
);

MainMenu.propTypes = propTypes;
MainMenu.defaultProps = defaultProps;

export default MainMenu;
